import cn from 'classnames';
import type { ReactNode } from 'react';
import { NavLink } from 'react-router';
import { Tag } from '../tag';
import { Paragraph } from '../typography';
import { type FormattedTimeConfig, WidgetItemTimeTag } from './widget-item-time-tag';

export type TagMode = 'live';

type P = {
  activeDate: Date;
  additionalDescription?: ReactNode;
  additionalDescriptionRows?: number;
  alwaysShowTimeTag?: boolean;
  bordered?: boolean;
  className?: string;
  description?: ReactNode;
  descriptionRows?: number;
  icon?: ReactNode;
  item?: ReactNode;
  noPadding?: boolean;
  path: string;
  tags?: TagMode[];
  timeConfig: FormattedTimeConfig;
  title?: string;
};

const WidgetItem = ({
  activeDate,
  additionalDescription,
  additionalDescriptionRows = 2,
  alwaysShowTimeTag = false,
  bordered,
  className,
  description,
  descriptionRows = 2,
  icon,
  item,
  noPadding,
  path,
  tags,
  timeConfig,
  title,
}: P) => (
  <NavLink className={cn('widget-item', { 'widget-item--bordered': bordered }, className)} to={path}>
    <div className="widget-item__info">
      {(icon ?? title) ? (
        <Tag icon={icon} noBackground noPadding={noPadding}>
          {title}
        </Tag>
      ) : null}

      <WidgetItemTimeTag
        activeDate={activeDate}
        alwaysShowTimeTag={alwaysShowTimeTag}
        noPadding={noPadding}
        tags={tags}
        timeConfig={timeConfig}
      />
    </div>

    {description ? (
      <Paragraph ellipsis={{ rows: descriptionRows }} type="title" weight="bold">
        {description}
      </Paragraph>
    ) : null}

    {additionalDescription ? (
      <Paragraph ellipsis={{ rows: additionalDescriptionRows }} size="small">
        {additionalDescription}
      </Paragraph>
    ) : null}

    {item ? <div>{item}</div> : null}
  </NavLink>
);

export default WidgetItem;
